import { render, staticRenderFns } from "./SurgicalSafetyChecklist.vue?vue&type=template&id=80ffd732&scoped=true"
import script from "./SurgicalSafetyChecklist.vue?vue&type=script&lang=js"
export * from "./SurgicalSafetyChecklist.vue?vue&type=script&lang=js"
import style0 from "./SurgicalSafetyChecklist.vue?vue&type=style&index=0&id=80ffd732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ffd732",
  null
  
)

export default component.exports